// Session-persisted "recently viewed" listings per kind (home | vehicle), most-recent first.
// Keeps the last 3. Resets when the browser/tab is closed (sessionStorage).
const KEY = { home: "luxora_recent_home", vehicle: "luxora_recent_vehicle" };
const MAX = 3;

export const getRecent = (kind) => {
  try {
    const s = sessionStorage.getItem(KEY[kind]);
    const a = s ? JSON.parse(s) : [];
    return Array.isArray(a) ? a : [];
  } catch {
    return [];
  }
};

export const addRecent = (kind, item) => {
  try {
    if (!item || !item.id) return;
    let a = getRecent(kind).filter((x) => x.id !== item.id);
    a.unshift(item);
    a = a.slice(0, MAX);
    sessionStorage.setItem(KEY[kind], JSON.stringify(a));
  } catch {
    /* ignore */
  }
};
